import { Phone, ClipboardList } from "lucide-react";
import { CONTACT } from "../../data/content";
import { scrollToId } from "../../hooks/useSmoothScroll";

export default function MobileBar() {
  return (
    <div
      data-testid="mobile-bottom-bar"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-slate-200 bg-white/95 backdrop-blur-xl shadow-[0_-4px_20px_rgba(0,0,0,0.08)] lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={CONTACT.phoneHref}
        data-testid="mobilebar-call"
        className="flex items-center justify-center gap-2 py-3.5 font-semibold text-[#0E5A75] border-r border-slate-200"
      >
        <Phone className="h-4 w-4" /> Hívás
      </a>
      <button
        data-testid="mobilebar-quote"
        onClick={() => scrollToId("ajanlatkeres")}
        className="flex items-center justify-center gap-2 py-3.5 font-semibold text-white bg-[#0E5A75]"
      >
        <ClipboardList className="h-4 w-4" /> Ajánlatkérés
      </button>
    </div>
  );
}
